import { css } from "@emotion/core";
import { ErrorM } from "components/helpers/ErrorM";
import { useField, useFormikContext } from "formik";
import React, { useEffect, useState } from "react";
// import { useTheme } from '@emotion/react';

type RadioButtonsProps = {
  className?: string;
  options: string[];
  fieldname: string;
  label?: string;
  customOnChange?(): void;
  error?: boolean;
  booleanField?: boolean;
};
export const RadioButtons: React.FC<RadioButtonsProps> = ({
  className,
  options,
  fieldname,
  label,
  customOnChange,
  error,
  booleanField,
}) => {
  const [field, meta, helpers] = useField(fieldname);

  const onClickHandler = (option: string) => {
    booleanField
      ? helpers.setValue(option === "Yes" || option === "US" ? true : false)
      : helpers.setValue(option);
    helpers.setTouched(true, false);
  };

  const setSelected = (option: string) => {
    if (
      (field.value === true && (option === "Yes" || option === "US")) ||
      (field.value === false && (option === "No" || option === "Other"))
    ) {
      return true;
    } else {
      return false;
    }
  };

  let errorDefined = meta.error && meta.touched ? true : false;

  useEffect(() => {
    customOnChange && customOnChange();
  }, [customOnChange, field.value]); // we can use initialValues here since they shouldn't change

  useEffect(() => {
    if (booleanField) return; // don't do this validation for boolean fields
    if (options.length === 0 && field.value != null)
      return helpers.setValue(null);
    if (options.length > 0 && !options.includes(field.value))
      helpers.setValue(options[0]);
    if (options.length === 1 && field.value !== options[0])
      helpers.setValue(options[0]);
  }, [options, helpers, field.value, booleanField]);

  if (options.length === 1) return null;
  return (
    <>
      {label && (
        <div className="FormLabel">
          <label>{label}</label>
        </div>
      )}
      <div
        className={`${className ?? "RadioButtons"}${
          errorDefined ? " NoMargin" : ""
        }`}
      >
        {options.map((option, index) => (
          <React.Fragment key={index}>
            <RadioButton
              label={option}
              selected={
                booleanField ? setSelected(option) : option === field.value
              }
              onClick={() => onClickHandler(option)}
              error={errorDefined}
            />
          </React.Fragment>
        ))}
      </div>
      {errorDefined && <ErrorM name={fieldname} />}
    </>
  );
};

type RadioButtonProps = {
  label: string;
  selected: boolean;
  onClick: () => void;
  disabled?: boolean;
  bDangerousHtml?: boolean;
  classname?: string;
  error?: boolean | undefined;
};

export const RadioButton: React.FC<RadioButtonProps> = ({
  label,
  selected,
  onClick,
  disabled,
  bDangerousHtml,
  classname,
  error,
}) => {
  // const theme = useTheme();
  // const buttonCss = css`
  //     ${selected
  //         ? `background-color: ${theme.colors.secondBackground};
  //         border-color: ${theme.colors.second};
  //         span::before {
  //             background-color: ${theme.colors.second};
  //             border-color: ${theme.colors.second};
  //         }`
  //         : ''}
  // `;
  return (
    <button
      // css={buttonCss}
      className={`RadioButton ${selected ? "Selected" : ""} ${classname} ${
        bDangerousHtml === true ? "dangerous-html" : ""
      } ${error ? " ErrorInput" : ""}`}
      onClick={onClick}
      type="button"
      disabled={disabled}
    >
      {bDangerousHtml === true ? (
        <div
          className={`TCContentView`}
          dangerouslySetInnerHTML={{ __html: label }}
        ></div>
      ) : (
        <span>{label}</span>
      )}
    </button>
  );
};
